import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { apiFetch } from "@core/index";
import { apiEndpoint } from "../utils/constants";
import { InvoicePartiesPayload } from "../utils/types";

export const useCreateInvoiceParty = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: { payload: InvoicePartiesPayload }) => {
      const response = await apiFetch<{
        statusCode: number;
        message: string;
        data?: unknown;
      }>(`${apiEndpoint}`, {
        method: "POST",
        body: config.payload,
      });
      return response;
    },
    onSuccess: (response) => {
      if (response.statusCode >= 400) {
        enqueueSnackbar(response.message || "", {
          variant: "error",
          autoHideDuration: 5000,
        });
      } else {
        enqueueSnackbar("Invoice party created successfully.", {
          variant: "success",
          autoHideDuration: 2000,
        });
        queryClient.invalidateQueries({ queryKey: ["invoiceParties"] });
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar(
        "Failed to create a new invoice party. Error: " + (error.message ?? ""),
        {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        },
      );
    },
  });
};
